/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import FormValidate from './modules/form-validate'
_('', 'validate').nodes().map((el) => new FormValidate(el))

----------------------------------------------------------------------------
Base attributes:
----------------------------------------------------------------------------
data-validate      - root attribute
*/

import Validate from '../modules/validate.js'
export default class FormValidate {
    constructor(el) {
        this.form = el
        this.pristine = new Validate(this.form)
        this.form.addEventListener('submit', this.formSubmit)
    }

    formSubmit = (e) => {
        const valid = this.pristine.validate()

        if (!valid) {
            e.stopImmediatePropagation()
            e.preventDefault()
        }
    }
}
